import React from 'react';
import BlockContainer from './BlockContainer';

export default function ContentBlock({
  body,
  align,
  bgColor,
  textColor,
  padding,
}) {
  return body ? (
    <BlockContainer
      align={align}
      bgColor={bgColor}
      textColor={textColor}
      padding={padding}
      noWhiteSpace
    >
      <div
        className="max-w-3xl mx-auto"
        dangerouslySetInnerHTML={{ __html: body }}
      ></div>
    </BlockContainer>
  ) : null;
}
